import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import CartCard1 from "../../components/CartCheckOrderCard/CartCard1";
import Loading from "../../shared/Loading";
import axiosInstance from "../../utilities/axiosInstance/axiosInstance";

const Cart = ({ handleChanges, changes }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [st, setST] = useState(0);
  const [gt, setGT] = useState(0);
  const [d, setD] = useState(0);
  const userInfo = JSON.parse(localStorage.getItem("user"));

  // discount data
  const {
    isLoading,
    isError,
    data: discount,
    error,
  } = useQuery(["discountdata"], async () => {
    let fdata = await axiosInstance.get("discount/get-active?limit=1");
    // console.log(fdata.data[0]);
    return fdata.data[0];
  });
  // cart dataa
  const {
    isLoading1,
    isError1,
    data: cartdata,
    error1,
  } = useQuery(["cartdatacartpages", changes], async ({ changes }) => {
    // console.log(_id);
    console.log(changes);
    let returndata = await axiosInstance.get(
      `cart/find-details?userId=${userInfo?._id}`
    );
    // if (returndata?.data === null || returndata?.data?.products?.length === 0)
    //   return {};

    let stTem = 0;
    returndata?.data?.products?.map((x) => {
      let upd =
        x?.productId?.unit_price -
        (x?.productId?.unit_price * discount?.value) / 100;

      stTem += (x?.productId?.unit_price - upd) * x?.quantity;
    });

    setST(stTem);
    return returndata?.data;
  });
  // console.log(cartdata);

  // cart update option
  const handleCartUpdate = async (id, q) => {
    let tem = cartdata?.products;
    tem.map((x, index) => {
      if (x?.productId?._id === id) {
        tem[index].quantity = q;
      }
    });
    let res = await axiosInstance.put(
      `cart/update?_id=${cartdata?._id}&&userId=${userInfo._id}`,
      tem
    );
    // console.log(res);
    handleChanges(changes + 1);
  };

  // cart delete a item option
  const handleDeleteCart = async (id) => {
    let tem = cartdata.products;
    let updatedArr = [];
    tem.map((x) => {
      if (x.productId._id !== id) {
        updatedArr.push(x);
      }
    });

    let res = await axiosInstance.put(
      `cart/update?_id=${cartdata?._id}&&userId=${userInfo._id}`,
      updatedArr
    );
    // console.log(res);
    handleChanges(changes + 1);
  };

  if (isLoading1 || isLoading || loading) return <Loading></Loading>;

  return (
    <div className="w-full flex flex-col justify-center items-center lg:px-20 sm:px-4 my-20">
      <p className="text-sm font-bold text-left w-full">Your Cart</p>
      <div className="grid grid-cols-1 gap-4 mt-6 w-full">
        {cartdata === null || cartdata?.products?.length === 0 ? (
          <div className="w-full mt-6 p-6 bg-gray-200 rounded text-xs">
            <p>No Cart Data Found</p>
          </div>
        ) : (
          cartdata?.products?.map((x, index) => {
            return (
              <CartCard1
                handleCartUpdate={handleCartUpdate}
                handleDeleteCart={handleDeleteCart}
                discount={discount}
                key={index}
                data={x}
              ></CartCard1>
            );
          })
        )}
      </div>

      <div className="mt-6 p-5 flex justify-between w-full bg-green-300">
        <div></div>
        <div>
          <p className="">Sub Total: {st}</p>
        </div>
      </div>

      <button
        disabled={
          cartdata === null || cartdata?.products?.length === 0 ? true : false
        }
        onClick={() => navigate("/checkout")}
        className="btn btn-wide border-none bg-green-500 text-white rounded-none mt-6"
        type=""
      >
        CheckOut
      </button>
    </div>
  );
};

export default Cart;
